import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { UserResource } from "../../../../api/users";

interface ResendActivationFormProperties {
  userId: string;
  userEmail: string;
  onClose: () => void;
}

export const ResendActivationForm: React.FC<ResendActivationFormProperties> = ({
  userId,
  userEmail,
  onClose,
}) => {
  const onResend = async () => {
    console.log("Resending activation to user: ", userEmail, userId);
    try {
      await UserResource.resendActivation(
        {
          id: userId,
        },
        {}
      );
    } catch (e) {
      console.error("Error resending activation: ", e);
      console.log(e);
    }
    onClose();
  };

  return (
    <>
      <DialogTitle>Send a new activation link?</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="body1">
          This will invalidate the previous activation link and send a new one
          to the user.
        </Typography>
        <Typography variant="body1">User: {userEmail}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onResend} variant="contained">
          Resend activation
        </Button>
      </DialogActions>
    </>
  );
};
